// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__U6nvB","formcontainer":"Contact_formcontainer__iNrBQ"};